import { api, errMsg, getToken, setToken } from "@/lib/api";
import { clientMods } from "@/lib/clients";

// §79 Client Admin: client companies with users, logos, modules, pause, activity, view-as, weekly digest.
export const CA = "/admin/clients";
export const DAYS = [["mon", "Monday"], ["tue", "Tuesday"], ["wed", "Wednesday"], ["thu", "Thursday"], ["fri", "Friday"], ["sat", "Saturday"], ["sun", "Sunday"]];
export const caErr = (e) => (e?.response?.status === 404 ? "Client Admin isn't live on the backend yet (spec §79)." : errMsg(e));
export const inviteUrls = (c, name, message) => {
  const accept_url = `${window.location.origin}/client/accept`;
  const login_url = `${window.location.origin}/client/login`;
  if (!c) return { accept_url, login_url };
  const m = clientMods(c);
  const radar = m.radar?.length > 0;
  const items = [radar && ["Opportunity Radar", "Companies that need to hire now, scored 0-100 with a plain-words why-now, plus the decision makers to contact."],
    radar && m.workflows !== false && ["Automated Workflows", "Your own searches that find and score new companies for you every week."],
    radar && m.mpc !== false && ["MPC Marketplace", "Package your best candidates and match them to companies hiring that role."],
    radar && m.linkedin !== false && ["LinkedIn Follow-Ups", "3-email follow-ups for people you connect with, sent from your own mailbox."],
    radar && m.intel !== false && ["Market Intelligence", "Sourced reports and posts built from your radar's hiring and funding signals."],
    radar && ["Email Campaigns", "Multi-step email, LinkedIn and call outreach the AI writes for you."],
    m.si && ["Sourcing Intelligence", "AI candidate search, Quick people search, My Talent & Connections, and ranked shortlists for every job."]].filter(Boolean);
  const first = (name || "").trim().split(" ")[0] || "there";
  const esc = (s) => String(s).replace(/[&<>"]/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch]));
  return {
    accept_url, login_url,
    user_type: "client", skip_job_seeker_onboarding: true,
    invite_email: {
      template: "/email-template-business.html",
      subject: `${c.company}: your MyNextBigMove recruiting workspace is ready`,
      preheader: `You've been invited to ${c.company}'s Recruiting Intelligence workspace.`,
      eyebrow: "Your workspace invite",
      title: `Welcome to ${esc(c.company)}'s recruiting workspace`,
      body_html: `<p>Hi ${esc(first)},</p><p>You've been given access to the MyNextBigMove Recruiting Intelligence &amp; Revenue Command Center for <b>${esc(c.company)}</b>. It helps you find companies that need to hire, reach the people who decide, and match the right talent.</p>${message ? `<p>${esc(message)}</p>` : ""}<p>Click the button to accept your invite. You can sign in with Google or set a password. The link works for 7 days.</p>`,
      secondary_html: `<p style="margin:0 0 8px"><b>What you can use:</b></p><ul style="margin:0;padding-left:18px">${items.map(([t, d]) => `<li style="margin:0 0 6px"><b>${t}</b>: ${d}</li>`).join("")}</ul><p style="margin:12px 0 0">Already set up? Sign in any time at <a href="${login_url}">${login_url.replace(/^https?:\/\//, "")}</a>.</p>`,
      cta_label: "Accept invite & sign in",
      cta_url: "{{accept_link}}",
      footer_note: "You're receiving this because someone at RPOPRO invited you to a client workspace.",
    },
  };
};

const ADMIN_KEY = "rpopro_admin_token";
const VIEW_KEY = "rpopro_view_as";
export const startViewAs = async (c) => {
  const { data } = await api.post(`${CA}/${c.id}/view-as`, {});
  localStorage.setItem(ADMIN_KEY, getToken());
  localStorage.setItem(VIEW_KEY, c.company);
  setToken(data.session_token);
  window.location.assign("/client");
};
export const viewingAs = () => localStorage.getItem(VIEW_KEY);
export const exitViewAs = () => {
  const t = localStorage.getItem(ADMIN_KEY);
  localStorage.removeItem(ADMIN_KEY); localStorage.removeItem(VIEW_KEY);
  if (t) setToken(t);
  window.location.assign("/admin/clients");
};
